import { SearchTerm } from './SearchTerm';

const AlarmViewerSearch: SearchTerm[] = [
    {
        heading: "Event",
        accessor: "event",
        searchOnName: "event",
        translationKey: "event"
    },
    {
        heading: "Acknowledged By",
        accessor: "acknowledgedBy",
        searchOnName: "acknowledgedBy",
        translationKey: "acknowledgedBy"
    },
    {
        heading: "Device",
        accessor: "device",
        searchOnName: "device",
        translationKey: "device"
    },
    {
        heading: "Card Number",
        accessor: "tagCode",
        searchOnName: "tagCode",
        translationKey: "tagCode"
    },
    {
        heading: "Site",
        accessor: "site",
        searchOnName: "site",
        translationKey: "site"
    },
    {
        heading: "Credential Holder",
        accessor: "credentialHolder",
        searchOnName: "credentialHolder",
        translationKey: "credentialHolder"
    }
]

export default AlarmViewerSearch;
